import React from 'react';

interface BillingPaneHeadersProps {
  setPane: (string) => void;
  pane: string;
}
export const BillingPaneHeaders = ({ setPane, pane }: BillingPaneHeadersProps) => (
  <div className="panel-header flex mt-20">
    <div
      role="button"
      tabIndex={0}
      onClick={() => setPane('subscription')}
      onKeyPress={() => setPane('subscription')}
    >
      <p className={`fsz-16 mr-20 py-10 ${pane === 'subscription' ? 'active' : ''}`}>
        Subscription Details
      </p>
    </div>
    <div
      role="button"
      tabIndex={0}
      onClick={() => setPane('usage')}
      onKeyPress={() => setPane('usage')}
    >
      <p className={`fsz-16 mr-20 py-10 ${pane === 'usage' ? 'active' : ''}`}>
        Balance and Usage
      </p>
    </div>
  </div>
);
